import { ReactNode } from 'react';
import { BsViewList } from 'react-icons/bs';
import { LuCalendarDays, LuHome } from 'react-icons/lu';
import { FaSeedling } from 'react-icons/fa';
import { useNavigation } from '../hooks/useNavigation';

const tabs = [
  { name: 'Home', path: '/', icon: <LuHome size={26} /> },
  { name: 'Transactions', path: '/transactions', icon: <BsViewList size={26} /> },
  { name: 'Portfolio', path: '/portfolio', icon: <FaSeedling size={24} /> },
  { name: 'Bills', path: '/bills', icon: <LuCalendarDays size={26} /> }
];

interface AppNavigationProps {
  activePath: '/' | '/portfolio' | '/transactions' | '/bills';
  children: ReactNode;
  isMobile: boolean;
}

function AppNavigation({ activePath, children, isMobile }: AppNavigationProps) {
  const { navigateTo } = useNavigation();

  const renderTabButton = (tab: typeof tabs[number]) => {
    const isActive = tab.path === activePath;
    return (
      <button
        type="button"
        key={tab.name}
        onClick={(e) => {
          e.preventDefault();
          if (!isActive) {
            navigateTo(tab.path, { replace: true });
          } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }}
        className={
          isMobile
            ? `flex-1 w-full min-h-12 flex flex-col items-center justify-center gap-1 focus:outline-none ${isActive ? 'accent-secondary-foreground' : 'text-muted-foreground'}`
            : `h-14 w-full flex flex-col items-center justify-center gap-1 focus:outline-none transition-colors ${isActive ? 'text-foreground' : 'text-muted-foreground hover:text-foreground hover:bg-muted/20'}`
        }
        aria-label={tab.name}
      >
        {tab.icon}
      </button>
    );
  };

  if (!isMobile) {
    return (
      <nav className="fixed inset-0 flex bg-background text-foreground disable-scroll">
        <div
          className="flex flex-shrink-0 flex-col items-center border-r border-border/40 bg-background pt-0"
          style={{
            paddingLeft: 'env(safe-area-inset-left)',
          }}
        >
          <div className="flex w-12 flex-col">
            {tabs.map(renderTabButton)}
          </div>
        </div>
        <div className="min-w-0 flex-grow overflow-hidden bg-background">
          {children}
        </div>
      </nav>
    );
  }

  return (
    <nav className="w-full flex flex-col fixed bottom-0 disable-scroll h-full">
      <div className="flex-grow bg-background overflow-hidden">
        {children}
      </div>
      <div
        className="flex flex-shrink-0 border-t border-border"
        style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      >
        {tabs.map((tab) => {
          return renderTabButton(tab);
        })}
      </div>
    </nav>
  );
}

export default AppNavigation; 
